import { useQuery } from 'react-query';

import { getObject } from 'api/clients/getObject';

export const useGetObject = (id?: number) => {
  const { data, refetch, isLoading } = useQuery(['object', id], () => getObject(id as number), {
    enabled: !!id,
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });

  return { data, refetch, isLoading };
};

export default useGetObject;
